import { useEffect, useMemo, useRef, useState } from 'react';

const Selection = ({ users, losesAccess }) => {
  const [selected, setSelected] = useState(new Set());
  const headerCheckboxRef = useRef(null);

  const allSelected = useMemo(() => {
    return users.length > 0 && users.every((u) => selected.has(u.Id));
  }, [users, selected]);

  const someSelected = selected.size > 0 && !allSelected;

  useEffect(() => {
    if (headerCheckboxRef.current) {
      headerCheckboxRef.current.indeterminate = someSelected;
    }
  }, [someSelected]);

  const clearSelection = () => setSelected(new Set());

  const toggleOne = async (id) => {
    const lostAccess = await losesAccess?.();
    if (lostAccess) return;
    setSelected((prev) => {
      const next = new Set(prev);
      next.has(id) ? next.delete(id) : next.add(id);
      return next;
    });
  };

  const toggleAllFiltered = async () => {
    const lostAccess = await losesAccess?.();
    if (lostAccess) return;
    setSelected((prev) => {
      const next = new Set(prev);
      if (allSelected) users.forEach((u) => next.delete(u.Id));
      else users.forEach((u) => next.add(u.Id));
      return next;
    });
  };

  return {
    selected,
    setSelected,
    headerCheckboxRef,
    allSelected,
    someSelected,
    clearSelection,
    toggleOne,
    toggleAllFiltered,
  };
};

export default Selection;
